module.exports = __webpack_public_path__ + "static/media/yitihuan.8ee55078.png";